import React, { useEffect, useState } from 'react';

import { SelectType, TextSize } from '../../models/enum';
import { useRouter } from 'next/router';
import { Section } from '../../models/domain/interfaces';
import {
  SortingSelectStyled,
  TitleStyled,
  WrapperStyled,
} from './SortingFilters.styled';

interface IProps {
  handleFilterButtonClick: () => void;
  translations: any;
  filterSections: Section[];
}

const SortingFilters: React.FC<IProps> = ({ filterSections }) => {
  const [sorting, setSorting] = useState(
    filterSections?.[0]?.voices?.find?.(({ active }: any) => {
      return active;
    })?.link ||
      filterSections?.[0]?.voices?.[0]?.link ||
      ''
  );
  const router = useRouter();

  useEffect(() => {
    setSorting(
      filterSections?.[0]?.voices?.find?.(({ active }: any) => {
        return active;
      })?.link ||
        filterSections?.[0]?.voices?.[0]?.link ||
        ''
    );
  }, [filterSections, router.asPath]);

  return (
    <WrapperStyled>
      <TitleStyled>{filterSections?.[0]?.title}:</TitleStyled>
      <SortingSelectStyled
        currentValue={sorting}
        type={SelectType.secondary}
        textSize={TextSize.small}
        onChange={(val: any) => {
          const link = val as string;
          setSorting(link);
          router.push(link);
        }}
        options={filterSections}
      />
    </WrapperStyled>
  );
};

export default SortingFilters;
